<template>
  <dv-scroll-board :config="config" style="width:100%; height:340px" />
</template>

<script>
//专区排行
export default {
  name: "XList",
  data() {
    return {
      config: {},
    }
  },
  methods:{

  },
  created() {



    let data=[];
    data[0]=['确山县金顶山风景区',5,100,6];
    data[1]=['确山县靖宇广场',5,120,4];
    data[2]=['确山县水韵太极湾',5,80,3];
    data[3]=['金雀会议大厅',10,150,10];

      this.config = {
        header: [ '演出地点','出演场次', '相亲人数', '结队人数'],
        rowNum:[4],
        data: data,
        headerBGC: '#0081EE',
        oddRowBGC: '#0e0e26',
        evenRowBGC: '#0e0e26',
        index: false,
        columnWidth: [500,450,250,250],
        align: ['center']
      }
    


  },

  watch: {

  }
}
</script>

<style scoped>
.galleries {
  width: 100%;
  height: 100%;
}
</style>